import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import * as CONSTANTS from "../CONSTANTS";
import './singlemag.css';
import axios from 'axios';
import Preloader from "../Components/Preloader";
import { FaDownload, FaHome } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

function SingleMagazine() {

  const params                                                                    = useParams();
  const [magazineDetails, setMagazineDetails]                                     = useState(null);

  const [images, setImages]                 = useState([]);
  const [currentIndex, setCurrentIndex]     = useState(0);
  const [slideDirection, setSlideDirection] = useState("none");
  const [zoomState, setZoomState]           = useState({});

  const [pdfLink, setPDFLink]                          = useState();

  const [loadVisible, setLoadVisible]                  = useState(true);
  const [totalPages, setTotalPages]                    = useState(0);
  const [slideStep, setSlideStep]                      = useState(window.innerWidth <= 768 ? 1 : 2);
  const [interActString, setInterActString]            = useState("Double click for zooming in and out.");

  const imageRefs = useRef({});
  
  const [isLoading, setIsLoading]                      = useState(true);

  useEffect(() => {
    collectCurrentMagazine();
    getPDFLink();
  },[])

  const collectCurrentMagazine = async () => {
        try{

            const currentID = params.id;
            
            const res = await axios.get(CONSTANTS.API_URL +"api.php?fullscript=" + CONSTANTS.ACCESSCODE + "&issue=" + currentID);
            console.log(res.data);
            setImages(res.data.list)
            setMagazineDetails(res.data.data);
            setTotalPages(res.data.list.length);

            ///////////////////////
            // Preload images
            let loadedCount = 0;
            res.data.list.forEach((src) => {
              const img = new Image();
              img.src = src;
              img.onload = img.onerror = () => {
                loadedCount++;

                if(loadedCount === 13){
                  setTimeout(() => setLoadVisible(false), 300);
                }

                if (loadedCount === res.data.list.length) {
                  setTimeout(() => setIsLoading(false), 300); // slight delay for better UX
                }
              };
            });
            /////////////////////
        }catch(err){
            console.log(err);
        }
  }

  const getPDFLink = async () => {
        try{

            const currentID = params.id;
            
            const res = await axios.get(CONSTANTS.API_URL +"api.php?pdfissue=" + currentID);

            ///////////////////////
        
            if(res.data.length !== 0){
              
               setPDFLink(res.data.file_path);
            }
            /////////////////////
        }catch(err){
            console.log(err);
        }
  }

  useEffect(() => {
    //check screen size
    const handleResize = () => {
        setSlideStep(window.innerWidth <= 768 ? 1 : 2);

        setInterActString(
          window.innerWidth <= 768 ? 
            "Pinch for zooming in or out."
          : "Double click for zooming in and out.");
    };

      window.addEventListener("resize", handleResize);

      // Set initial value
      handleResize();

      return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  const nextSlide = () => {
    if (currentIndex + slideStep < images.length) {
      setSlideDirection("right");
      setTimeout(() => {
        if(currentIndex === 0){
          setCurrentIndex(currentIndex + 1);
        }else {
          setCurrentIndex(currentIndex + slideStep);
        }
        setSlideDirection("none");
      }, 300);
    }
  };

  const prevSlide = () => {

     if (currentIndex - slideStep >= 0) {
     
      setSlideDirection("left");
      setTimeout(() => {
        setCurrentIndex(currentIndex - slideStep);
        setSlideDirection("none");
      }, 300);
    } else if ((slideStep === 2) && (currentIndex - slideStep === -1)) {

      setSlideDirection("left");
      setTimeout(() => {
        setCurrentIndex(0);
        setSlideDirection("none");
      }, 300);
    }
    
  };

  const getVisibleImages = () => {
    if (currentIndex === 0) return [images[0]];
    return images.slice(currentIndex, currentIndex + slideStep);
  };

  const handleDoubleClick = (imgUrl, e) => {
    const imgEl = imageRefs.current[imgUrl];
    if (!imgEl) return;

    const rect = imgEl.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const clickY = e.clientY - rect.top;

    const thirdWidth = rect.width / 3;
    const thirdHeight = rect.height / 3;

    let xRegion, yRegion;

    if (clickX < thirdWidth) xRegion = "left";
    else if (clickX > 2 * thirdWidth) xRegion = "right";
    else xRegion = "center";

    if (clickY < thirdHeight) yRegion = "top";
    else if (clickY > 2 * thirdHeight) yRegion = "bottom";
    else yRegion = "center";

    const origin =
      yRegion === "center" && xRegion === "center"
        ? "center center"
        : `${yRegion} ${xRegion}`;

    setZoomState((prev) => {
      const current = prev[imgUrl] || { scale: 1, origin: "center center" };
      const zoomedIn = current.scale > 1;

      return {
        ...prev,
        [imgUrl]: zoomedIn
          ? { scale: 1, origin: "center center" }
          : { scale: 1.6, origin },
      };
    });
  };
  
  return (
    <div className={"phase-lane slay-" + slideStep}>
      {loadVisible && <Preloader />}  
      {
        magazineDetails  !== null && (
          <Helmet>
            <title>{`theScript Magazine - Issue ${magazineDetails.issue}`}</title>
            <meta name="description" content={magazineDetails.title} />
          </Helmet>
        )
      }
      
      <div 
         className={`slider-container 
            ${
              currentIndex !== 0 && !(currentIndex === (images.length - 1) && currentIndex % 2 === 0)
                  ? 'full-pages '
                  : ''
            } 
            ${images.length % 2 === 0 ? 'even-part ' : 'odd-part '}
            ${(currentIndex + 1) === images.length ? 'lastpage' : ''}`}
        >
          <div className="top-navigate-block">
            
            <Link
              to="/"
              className="item-link-nav">
                <FaHome />
              </Link>
               {
                  pdfLink &&
                  pdfLink.length > 0 && (
                    <Link
                      to={pdfLink}
                      className="item-link-nav"
                      target="_blank"
                      >
                        <FaDownload />
                    </Link>
                  )
               }
             
          </div>
        {currentIndex > 0 && (
          <button className="arrow left" onClick={prevSlide}>
            ⬅
          </button>
        )}
          <div className={`image-track slide-${slideDirection}`}>
            {
              getVisibleImages().map((img, i) => {
                const zoom = zoomState[img] || { scale: 1, origin: "center center" };
                const transform = `scale(${zoom.scale})`;

                    return (
                      <img
                        ref={(el) => (imageRefs.current[img] = el)}
                        key={i}
                        src={img}
                        loading="lazy"
                        alt={`theScript ${currentIndex + i}`}
                        onDoubleClick={(e) => handleDoubleClick(img, e)}
                        className="slide-image"
                        style={{
                          transformOrigin: zoom.origin,
                          transform,
                        }}
                      />
                    )
                }
              )
            }
          </div>
        
        {
             slideStep === 2 ?
              <>
                {
                  currentIndex + 1 < images.length - 1 && (
                      <button className="arrow right" onClick={nextSlide}>
                        ➡
                      </button>
                    )
                }
              </> 
              :
              <>
              {
                    currentIndex + 1 <= images.length - 1 && (
                        <button className="arrow right" onClick={nextSlide}>
                          ➡
                        </button>
                    )
                }
            </>
        }
      </div>
      <div className="meta-info-content">
        {
          slideStep === 2 ?
          <>
             {currentIndex === 0 ? 
                <span>1</span>
                :
                <span>{currentIndex} - {currentIndex + 1} </span>
              } 
          </>
          :
           <>
            {slideStep + currentIndex}
           </>
        }     
        / 
        {totalPages}
      </div>
 
      <div className="meta-info-string">
        {interActString}
      </div>
    </div>
  );
}

export default SingleMagazine